import { gql } from '@apollo/client';
import { AD_BASE_FIELDS } from '@/api/queries/ads.queries';

export const GET_MY_ADS_LIST = gql`
  ${AD_BASE_FIELDS}
  query GetMyAdsList(
    $status: CurrentUserAdStatusEnum
    $first: Int
    $after: String
  ) {
    currentUserAds(status: $status, first: $first, after: $after) {
      nodes {
        ...AdBaseFields
        editLockedUntil
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

export const GET_CURRENT_USER_COUNTERS = gql`
  query GetCurrentUserCounters {
    currentUserCounters {
      archived
      awaitingPayment
      expired
      pending
      published
      rejected
    }
  }
`;

export const GET_MY_AD_DELETE_REASONS = gql`
  query GetMyAdDeleteReasons($id: ID!) {
    node(id: $id) {
      ... on Ad {
        id
        deleteReasons {
          id
          name
          descriptionRequired
        }
      }
    }
  }
`;

export const GET_MY_AD_PROMOTION_DETAILS = gql`
  query GetMyAdPromotionDetails($id: ID!) {
    node(id: $id) {
      ... on Ad {
        id
        legacyResourceId
        status
        updatedAt
        kinds
        vippedUntil
        featuredUntil
        bumpServices {
          price
          period
          previousPrice
        }
        vipServices {
          price
          period
          previousPrice
        }
        featuredServices {
          price
          period
          previousPrice
        }
        paymentMethods
        isAppleGooglePayEnabled
      }
    }
  }
`;
